"use client";

import React from "react";
import { ShieldCheck, Calculator, MapPin, Award } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyChooseUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const features = [{
    title: "Uncompromising Safety",
    description: "We ensure every operation meets international safety standards, providing consistent and secure ground support for global airlines.",
    icon: ShieldCheck
  }, {
    title: "Technical Innovation",
    description: "Utilizing advanced logistics modeling and technical precision to provide modern solutions for the most complex aviation challenges.",
    icon: Calculator
  }, {
    title: "Strategic Presence",
    description: "Headquartered at N’djili International Airport, we bridge the gap between regional logistics needs and global aviation standards.",
    icon: MapPin
  }, {
    title: "Elite Professionalism",
    description: "A commitment to excellence that defines our elite ground support, from aircraft handling to premium hospitality and protocol.",
    icon: Award
  }];
  return <section data-section-id="35152" id="our-professional-values" className="py-[120px] bg-background text-foreground relative overflow-hidden dark">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {}
          <div ref={ref} className={`flex flex-col justify-center h-full transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <h2 className="text-primary font-bold text-4xl md:text-5xl tracking-tighter mb-6 leading-tight">
              The Pillars of HLC Aviation Excellence
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed max-w-xl">
              At Handling and Logistic Company (HLC), we combine technical
              precision with elite service standards. As the premier partner at
              N’djili International Airport, we ensure that every cargo
              shipment, crew member, and passenger receives the height of
              professional care through our core operational values.
            </p>
          </div>

          {}
          <div className="grid sm:grid-cols-2 gap-6">
            {features.map((feature, i) => <div key={i} data-index={i} className={`transition-all duration-700 ease-out delay-[${i * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
                <Card className="h-full bg-card border border-primary/10 shadow-2xl hover:shadow-primary/5 transition-all duration-300 group relative overflow-hidden rounded-sm">
                  {}
                  <div className="absolute bottom-0 left-0 w-full h-1 bg-primary scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
                  
                  <CardContent className="p-8 flex flex-col gap-5">
                    <feature.icon className="w-10 h-10 text-primary stroke-[1.5] drop-shadow-[0_0_8px_rgba(255,191,0,0.3)]" />
                    <div>
                      <h3 className="font-semibold text-primary text-xl mb-3 tracking-tight">
                        {feature.title}
                      </h3>
                      <p className="text-sm text-muted-foreground leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}